<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/1 w-full">
      <vs-input class="w-full mt-4" label="Código" v-model="data.code" name="code" autofocus />
      <vs-input class="w-full mt-4" label="Valor/Percentual" v-model="data.amount" name="amount" autofocus />
      <vs-input class="w-full mt-4" label="Quantidade" v-model="data.quantity" name="quantity" autofocus />

      <div class="vx-row">
        <div class="vx-col md:w-4/12 w-full">
          <vs-select v-model="data.type" name="type" label="Tipo" class="w-full mt-4">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in type" />
          </vs-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-6/12 w-full text-center">
          <vs-button class="mt-4" icon-pack="feather" icon="icon icon-file" @click="save">Salvar</vs-button>
        </div>
        <div class="vx-col md:w-6/12 w-full text-right">
          <vs-button class="mt-4" icon-pack="feather" color="danger" @click="$router.push('/coupons')"
          >Cancelar
          </vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      ptBR,
      data: {
        title: null,
        url: null,
        type: 1,
        sort: '0',
      },
      type: [
        {
          text: 'Valor',
          value: 'AMOUNT'
        },
        {
          text: 'Percentual',
          value: 'PERCENTAGE'
        }
      ]
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      if (parseInt(this.$route.params.id) > 0) {
        this.$api
        .get(`/api/v1/backend/coupon/${this.$route.params.id}`)
        .then((response) => {
          this.$vs.loading.close()
          this.data = response.data
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },
    save() {
      this.$vs.loading()

      this.$api({
        method: this.$route.params.id ? 'PATCH' : 'POST',
        url: this.$route.params.id ? `/api/v1/backend/coupon/${this.$route.params.id}` : '/api/v1/backend/coupon',
        data: this.data
      })
      .then((response) => {
        this.$vs.loading.close()
        this.data = response.data

        this.$vs.notify({
          text: 'Salvo',
          color: 'success'
        })

        this.$router.push('/coupons')
      })
      .catch((error) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Erro',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
  }
}
</script>
